import React from "react";
import PropTypes from "prop-types";
import Information from "rialto-icons/Information";

import CancelButton from "components/CancelButton";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "components/Modal";
import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";

import styles from "./Dialog.css";

const { t } = new Translate("Dialog");

const Dialog = (props) => {
  const {
    cancelLabel,
    children,
    confirmLabel,
    info,
    isCancelable,
    isOpen,
    onCancel,
    onConfirm,
    title,
  } = props;

  return (
    <Modal isOpen={isOpen} onClose={onCancel} width={450}>
      <ModalHeader onClose={onCancel}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      {info && (
        <ModalBody>
          <div className={styles.info}>
            <Information /> {info}
          </div>
        </ModalBody>
      )}
      <ModalFooter>
        {isCancelable && <CancelButton onClick={onCancel} text={cancelLabel} />}
        <SubmitButton onSubmit={onConfirm} submitLabel={confirmLabel} />
      </ModalFooter>
    </Modal>
  );
};

Dialog.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isOpen: PropTypes.bool,
  isCancelable: PropTypes.bool,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
};

Dialog.defaultProps = {
  title: t("title"),
  cancelLabel: t("cancel"),
  confirmLabel: t("confirm"),
};

export default Dialog;
